import { Fragment } from "react";
import { SisenseContextProvider } from "@sisense/sdk-ui";

import useClubPerformanceAthleteTimesDetail from "./UseClubPerformanceAthleteTimesDetail";

import IndividualTimesSearchDashboard from "./IndividualTimesSearchDashboard";

import * as DM from '../../../../../usas-times-data';

import Headings from "@usas/ui-web/components/headings/Headings";
import { getConfig } from '@usas/ui-web/config/RuntimeConfig';

const ClubPerformanceAthleteTimesDetail = () => {
  const { environmentVariableState, INDIVIDUAL_TIMES_SEARCH_OID } = useClubPerformanceAthleteTimesDetail();

  return (
    <Fragment>
      {environmentVariableState.isLoaded === true &&
        <SisenseContextProvider
          defaultDataSource={DM.DataSource}
          url={getConfig().VITE_SISENSE_URL}
          token={import.meta.env.VITE_SISENSE_API_TOKEN}>
          <div className="row usas-extra-bottom-margin">
            <div className="col-xs-12">
              <Headings.H3>Athlete Times Detail</Headings.H3>
              <IndividualTimesSearchDashboard dashboardOid={INDIVIDUAL_TIMES_SEARCH_OID} />
            </div>
          </div>
        </SisenseContextProvider>
      }
    </Fragment>
  );
};

export default ClubPerformanceAthleteTimesDetail;